import { useI18n } from 'vue-i18n';

export function viteConfig(key, { defaultValue = undefined, parse = true } = {}) {
  const raw = import.meta.env['VITE_' + key];
  if (raw === undefined) return defaultValue;

  if (!parse) return raw;

  // try boolean
  if (raw === 'true') return true;
  if (raw === 'false') return false;

  // try number (safe)
  const num = Number(raw);
  if (!Number.isNaN(num) && raw.trim() !== '') return num;

  // try JSON
  try {
    return JSON.parse(raw);
  } catch (e) {
    // not JSON -> return original string
    return raw;
  }
}

export function formatSportTitle(sportKey) {
  if (!sportKey) return '';
  const { t } = useI18n();
  const translationKey = `events.sports.${sportKey}`;
  const translatedTitle = t(translationKey);
  if (translatedTitle !== translationKey) {
    return translatedTitle;
  }
  return sportKey.replace(/_/g, ' ').toUpperCase();
}

export function setPageTitle(title) {
  const baseTitle = viteConfig('APP_NAME');
  if (typeof document !== 'undefined'){
    document.title = title ? `${title} | ${baseTitle}` : baseTitle;
  }
}
